/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeRangeSchema } from './TimeRangeSchema';
import {
    TimeRangeSchemaFromJSON,
    TimeRangeSchemaFromJSONTyped,
    TimeRangeSchemaToJSON,
} from './TimeRangeSchema';

/**
 * 
 * @export
 * @interface GridJobInstanceSchema
 */
export interface GridJobInstanceSchema {
    /**
     * Unique identifier for the record
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    id?: any | null;
    /**
     * Universal unique identifier for the record
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    uuid?: any | null;
    /**
     * Created at this point in time
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    createdAt?: any | null;
    /**
     * Created by this user
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    createdBy?: any | null;
    /**
     * Modified at this point in time
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    modifiedAt?: any | null;
    /**
     * Modified by this user
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    modifiedBy?: any | null;
    /**
     * job id
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    jobId: any | null;
    /**
     * 
     * @type {TimeRangeSchema}
     * @memberof GridJobInstanceSchema
     */
    timerange: TimeRangeSchema;
    /**
     * Status of the job
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    status?: any | null;
    /**
     * Time when the job started
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    startedAt?: any | null;
    /**
     * Time when the job started
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    finishedAt?: any | null;
    /**
     * Log message of the job
     * @type {any}
     * @memberof GridJobInstanceSchema
     */
    logMessage?: any | null;
}

/**
 * Check if a given object implements the GridJobInstanceSchema interface.
 */
export function instanceOfGridJobInstanceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobId" in value;
    isInstance = isInstance && "timerange" in value;

    return isInstance;
}

export function GridJobInstanceSchemaFromJSON(json: any): GridJobInstanceSchema {
    return GridJobInstanceSchemaFromJSONTyped(json, false);
}

export function GridJobInstanceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GridJobInstanceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : json['modified_at'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'jobId': json['job_id'],
        'timerange': TimeRangeSchemaFromJSON(json['timerange']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'startedAt': !exists(json, 'started_at') ? undefined : json['started_at'],
        'finishedAt': !exists(json, 'finished_at') ? undefined : json['finished_at'],
        'logMessage': !exists(json, 'log_message') ? undefined : json['log_message'],
    };
}

export function GridJobInstanceSchemaToJSON(value?: GridJobInstanceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt,
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt,
        'modified_by': value.modifiedBy,
        'job_id': value.jobId,
        'timerange': TimeRangeSchemaToJSON(value.timerange),
        'status': value.status,
        'started_at': value.startedAt,
        'finished_at': value.finishedAt,
        'log_message': value.logMessage,
    };
}

